module.exports = __webpack_public_path__ + "static/media/1_en.ec9b85ef.png";